import { AppointmentTypeEnums } from "app/services/api/types/calendar/enums/AppointmentTypeEnums";

export type AppointmentStyle = {
  backgroundColor: string;
  borderLeftColor: string;
  textColor: string;
};

export const APPOINTMENT_STYLES: Record<
  AppointmentTypeEnums,
  AppointmentStyle
> = {
  [AppointmentTypeEnums.MEDICAL_APPOINTMENT]: {
    backgroundColor: "#F1F5FF",
    borderLeftColor: "#2C62F7",
    textColor: "#0E48E9",
  },
  [AppointmentTypeEnums.PERSONAL_APPOINTMENT]: {
    backgroundColor: "#F3EFFE",
    borderLeftColor: "#8B5CF6",
    textColor: "#6D28D9",
  },
  [AppointmentTypeEnums.GOVERNMENTAL_APPOINTMENT]: {
    backgroundColor: "#DDF5FF",
    borderLeftColor: "#0096D2",
    textColor: "#006A94",
  },
  [AppointmentTypeEnums.OUTINGS]: {
    backgroundColor: "#E7F8F2",
    borderLeftColor: "#10B981",
    textColor: "#047857",
  },
  [AppointmentTypeEnums.VITAL_CHECKS]: {
    backgroundColor: "#D2FCFF",
    borderLeftColor: "#00A5B1",
    textColor: "#00747C",
  },
  [AppointmentTypeEnums.MEDICATION_EVENT]: {
    backgroundColor: "#F2F4F7",
    borderLeftColor: "#98A2B3",
    textColor: "#475467",
  },
  [AppointmentTypeEnums.OTHER]: {
    backgroundColor: "#F2F4F7",
    borderLeftColor: "#98A2B3",
    textColor: "#475467",
  },
};
